export const HEADER_SCROLL_DEFAULTS = {
  showAt: 24,
  collapseAt: 96,
  intentThreshold: 10,
}

export function createHeaderScrollState(scrollY = 0) {
  const y = Math.max(0, Number(scrollY) || 0)
  return {
    collapsed: false,
    lastY: y,
    anchorY: y,
    direction: null,
  }
}

// Downward motion uses a small intent threshold so touch jitter does not collapse
// the chrome. Any upward movement restores it immediately, matching native
// mobile navigation where one reversal is enough to bring controls back.
export function updateHeaderScrollState(state, scrollY, options = HEADER_SCROLL_DEFAULTS) {
  const y = Math.max(0, Number(scrollY) || 0)

  if (y <= options.showAt) {
    return { collapsed: false, lastY: y, anchorY: y, direction: null }
  }

  const movement = y - state.lastY
  const direction = movement > 0 ? 'down' : movement < 0 ? 'up' : state.direction

  if (!direction) return state

  if (direction === 'up') {
    return { collapsed: false, lastY: y, anchorY: y, direction }
  }

  if (direction !== state.direction) {
    return { ...state, lastY: y, anchorY: y, direction }
  }

  if (Math.abs(y - state.anchorY) < options.intentThreshold) {
    return { ...state, lastY: y }
  }

  if (direction === 'down' && y >= options.collapseAt) {
    return { collapsed: true, lastY: y, anchorY: y, direction }
  }

  return { ...state, lastY: y }
}
